"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Message_1 = __importDefault(require("../i18n/Message"));
var FormFieldControl_1 = __importDefault(require("./FormFieldControl"));
var prop_types_1 = __importDefault(require("prop-types"));
var Form_1 = __importDefault(require("react-bootstrap/Form"));
var react_i18next_1 = require("react-i18next");
var FormField = function (props) {
    var controlType = props.controlType, controlId = props.controlId, _a = props.readOnly, readOnly = _a === void 0 ? false : _a, options = props.options, fieldNameId = props.fieldNameId, fieldName = props.fieldName, _b = props.showLabel, showLabel = _b === void 0 ? false : _b, remarkId = props.remarkId, placeholderId = props.placeholderId, invalid = props.invalid, errorId = props.errorId, _c = props.errorIdValues, errorIdValues = _c === void 0 ? {} : _c, value = props.value, loading = props.loading, onBlur = props.onBlur, onChange = props.onChange, layout = props.layout;
    var t = react_i18next_1.useTranslation().t;
    var _d = react_1.useState(controlType ? controlType : options ? 'select' : 'input'), internalType = _d[0], setInternalType = _d[1];
    var _onBlur = function (fieldName, value, inputValue) {
        if (onBlur) {
            onBlur(fieldName, value, inputValue);
        }
    };
    var _onChange = function (fieldName, value, inputValue) {
        if (onChange) {
            onChange(fieldName, value, inputValue);
        }
    };
    var createFormField = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            fieldNameId && !readOnly && showLabel && (react_1.default.createElement(Form_1.default.Label, null,
                react_1.default.createElement(Message_1.default, { messageId: fieldNameId }),
                remarkId && react_1.default.createElement(Message_1.default, { messageId: remarkId }))),
            react_1.default.createElement(FormFieldControl_1.default, { fieldNameId: fieldNameId, fieldName: fieldName, placeholderId: placeholderId, controlType: internalType, options: options, readOnly: readOnly, invalid: invalid, value: value, loading: loading, onBlur: _onBlur, onChange: _onChange }),
            invalid && errorId && !readOnly && (react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid", style: { display: 'block' } },
                react_1.default.createElement(Message_1.default, { messageId: errorId, values: __assign({ field: fieldNameId ? t(fieldNameId) : fieldName }, errorIdValues) })))));
    };
    var createFormFieldHorizontal = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            fieldNameId && (react_1.default.createElement(Form_1.default.Label, { className: "mr-2 mb-0 mt-2 align-self-start text-nowrap", style: { minWidth: '25px' } },
                fieldNameId,
                remarkId && react_1.default.createElement(Message_1.default, { messageId: remarkId }))),
            react_1.default.createElement("div", { className: "d-flex flex-column mr-4" },
                react_1.default.createElement(FormFieldControl_1.default, { fieldNameId: fieldNameId, fieldName: fieldName, placeholderId: placeholderId, controlType: internalType, options: options, readOnly: readOnly, invalid: invalid, value: value, loading: loading, onBlur: _onBlur, onChange: _onChange }),
                invalid && errorId && !readOnly && (react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid", style: { display: 'block' } },
                    react_1.default.createElement(Message_1.default, { messageId: errorId, values: __assign({ field: fieldNameId ? t(fieldNameId) : fieldName }, errorIdValues) }))))));
    };
    return layout === 'horizontal' ? createFormFieldHorizontal() : createFormField();
};
FormField.propTypes = {
    controlId: prop_types_1.default.string,
    controlType: prop_types_1.default.string,
    fieldName: prop_types_1.default.string,
    fieldNameId: prop_types_1.default.string,
    showLabel: prop_types_1.default.bool,
    placeholderId: prop_types_1.default.string,
    remarkId: prop_types_1.default.string,
    errorId: prop_types_1.default.string,
    invalid: prop_types_1.default.bool,
    constraint: prop_types_1.default.any,
    options: prop_types_1.default.any,
    onBlur: prop_types_1.default.func,
    onChange: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
    value: prop_types_1.default.any,
    loading: prop_types_1.default.bool,
    layout: prop_types_1.default.string,
};
exports.default = FormField;
//# sourceMappingURL=FormField.js.map